export enum EPermissionFeature {
  // HOME
  HOME_KEY_IN = 'HOME_KEY_IN',
  HOME_TIME_TRACKER = 'HOME_TIME_TRACKER',
  HOME_MANAGEMENT_TEAM = 'HOME_MANAGEMENT_TEAM',
  HOME_SORT_CHECK_IN = 'HOME_SORT_CHECK_IN',
  HOME_CASH_DEPOSIT = 'HOME_CASH_DEPOSIT',

  // CASHIER
  CASHIER_VOID_TICKET = 'CASHIER_VOID_TICKET',
  CASHIER_DISCOUNT_ITEM = 'CASHIER_DISCOUNT_ITEM',
  CASHIER_DISCOUNT_TICKET = 'CASHIER_DISCOUNT_TICKET',
  CASHIER_CASH_PAYMENT = 'CASHIER_CASH_PAYMENT',

  // CREDIT_CARD
  CREDIT_CARD_VIEW = 'CREDIT_CARD_VIEW',
  CREDIT_CARD_REFUND = 'CREDIT_CARD_REFUND',
  CREDIT_CARD_VOID = 'CREDIT_CARD_VOID',
  CREDIT_CARD_ADJUST_TIP = 'CREDIT_CARD_ADJUST_TIP',

  // TICKET
  TICKET_VIEW = 'TICKET_VIEW',
  TICKET_REFUND = 'TICKET_REFUND',
  TICKET_VOID = 'TICKET_VOID',
  TICKET_ADJUST_TIP = 'TICKET_ADJUST_TIP',
  TICKET_EDIT = 'TICKET_EDIT',
  TICKET_DELETE = 'TICKET_DELETE',

  // REPORT
  REPORT_REVENUE = 'REPORT_REVENUE',
  REPORT_INCOME = 'REPORT_INCOME',
  REPORT_SERVICE = 'REPORT_SERVICE',
  REPORT_PRODUCT = 'REPORT_PRODUCT',
  REPORT_PAYROLL = 'REPORT_PAYROLL',
  REPORT_TIME_CLOCK = 'REPORT_TIME_CLOCK',
  REPORT_CASH_DEPOSIT = 'REPORT_CASH_DEPOSIT',
  REPORT_REVIEW = 'REPORT_REVIEW',
  REPORT_CONSENT_FORM = 'REPORT_CONSENT_FORM',

  // QUICK_VIEW
  QUICK_VIEW_VIEW = 'QUICK_VIEW_VIEW',
  QUICK_VIEW_SMS = 'QUICK_VIEW_SMS',
  QUICK_VIEW_EMAIL = 'QUICK_VIEW_EMAIL',
  QUICK_VIEW_PRINT = 'QUICK_VIEW_PRINT',

  // CASH_DRAWER
  CASH_DRAWER_OPEN = 'CASH_DRAWER_OPEN',

  // TURN
  TURN_VIEW = 'TURN_VIEW',
  TURN_SETTING = 'TURN_SETTING',
  TURN_RE_ORDER = 'TURN_RE_ORDER',
  TURN_CLEAR = 'TURN_CLEAR',
  TURN_EDIT = 'TURN_EDIT',

  // APPOINTMENT
  APPOINTMENT_VIEW = 'APPOINTMENT_VIEW',
  APPOINTMENT_BOOKING = 'APPOINTMENT_BOOKING',
  APPOINTMENT_EDIT = 'APPOINTMENT_EDIT',
  APPOINTMENT_SETTING = 'APPOINTMENT_SETTING',
  APPOINTMENT_DRAG = 'APPOINTMENT_DRAG',

  // GIFT_CARD
  GIFT_CARD_VIEW = 'GIFT_CARD_VIEW',
  GIFT_CARD_ADD = 'GIFT_CARD_ADD',
  GIFT_CARD_RESET = 'GIFT_CARD_RESET',
  GIFT_CARD_DELETE = 'GIFT_CARD_DELETE',
  GIFT_CARD_RESEND = 'GIFT_CARD_RESEND',

  // CUSTOMER
  CUSTOMER_VIEW = 'CUSTOMER_VIEW',
  CUSTOMER_ADD = 'CUSTOMER_ADD',
  CUSTOMER_EDIT = 'CUSTOMER_EDIT',
  CUSTOMER_UPDATE_POINT = 'CUSTOMER_UPDATE_POINT',
  CUSTOMER_DELETE = 'CUSTOMER_DELETE',

  // STAFF
  STAFF_VIEW = 'STAFF_VIEW',
  STAFF_ADD = 'STAFF_ADD',
  STAFF_EDIT = 'STAFF_EDIT',
  STAFF_DELETE = 'STAFF_DELETE',
  STAFF_SECURITY = 'STAFF_SECURITY',
  STAFF_SALARY = 'STAFF_SALARY',
  STAFF_SPECIALIZE = 'STAFF_SPECIALIZE',
  STAFF_SCHEDULE = 'STAFF_SCHEDULE',

  // CONTROL_PANEL
  CONTROL_PANEL_SERVICE = 'CONTROL_PANEL_SERVICE',
  CONTROL_PANEL_SIMPLE_MENU = 'CONTROL_PANEL_SIMPLE_MENU',
  CONTROL_PANEL_PRODUCT = 'CONTROL_PANEL_PRODUCT',
  CONTROL_PANEL_VIP = 'CONTROL_PANEL_VIP',
  CONTROL_PANEL_QUICK_PAY = 'CONTROL_PANEL_QUICK_PAY',
  CONTROL_PANEL_TURN = 'CONTROL_PANEL_TURN',
  CONTROL_PANEL_CONFIGURATIONS = 'CONTROL_PANEL_CONFIGURATIONS',
}

export type PermissionFeature = `${EPermissionFeature}`;

export enum EPermissionRole {
  ADMIN = 'ADMIN',
  CASHIER = 'CASHIER',
  MANAGER = 'MANAGER',
  TECHNICAL = 'TECHNICAL',
}

export type PermissionRole = `${EPermissionRole}` 

export enum EPermissionModule {
  HOME = 'HOME',
  CASHIER = 'CASHIER',
  CREDIT_CARD = 'CREDIT_CARD',
  TICKET = 'TICKET',
  REPORT = 'REPORT',
  QUICK_VIEW = 'QUICK_VIEW',
  CASH_DRAWER = 'CASH_DRAWER',
  TURN = 'TURN',
  APPOINTMENT = 'APPOINTMENT',
  GIFT_CARD = 'GIFT_CARD',
  CUSTOMER = 'CUSTOMER',
  STAFF = 'STAFF',
  CONTROL_PANEL = 'CONTROL_PANEL',
}

export type PermissionModule = `${EPermissionFeature}`;